//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../Tooling/Tooling.DefineNeutralFactorBuilder.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/SelectFaceList.js";
import "../no/SelectEdgeList.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AdditionalBendFaces",0,"ScCollector",0],[0,"Angle1",1,0],[0,"Angle2",1,0],[0,"Angle3",1,0],[0,"Angle4",1,0],[0,"Angle5",1,0],[0,"Angle6",1,0],[0,"CurBodies",1,0],[1,"DefineNeutralFactor",0,"Tooling.DefineNeutralFactorBuilder",0],[0,"DesignSequence",1,0],[0,"DevLength",1,1],[0,"EditOption",1,0],[0,"InterNamingRule",1,0],[0,"InterRenameComp",1,0],[1,"InterStage",0,"Assemblies.SelectComponent",0],[0,"KFactor",1,1],[0,"Materials",1,1],[0,"NumBends",1,0],[0,"NumInter",1,0],[0,"OrientPitch",1,0],[0,"Pitch",1,0],[1,"SelPlanarFaces",0,"SelectFaceList",0],[1,"SelectBend",0,"SelectFaceList",0],[1,"SelectStartEdge",0,"SelectEdgeList",0],[0,"StartStation",1,0],[0,"UnfoldType",1,0]],[[[],"LoadDatabase",{},0,1],[[],"KByMaterial",{},0,1],[["baseBody"],"ConvertToSheetMetal",{},1,0],[["mergeBendsFaces"],"MergeBends",{},1,0],[["selBends"],"DefinePreBends",{},1,0],[["bendFaces"],"DeleteBends",{},1,0],[["baseBody"],"CreateResizeNeutralFactorForBody",{},1,0],[["newKFactor","bendUDO"],"EditResizeNeutralFactorForBends",{},2,0],[["baseBody","numBends"],"GetAllBendsUDO",{R_:{bendsUDO:"NXObject[]"}},1,0],[["currentBody"],"SetCurrentBody",{},1,0]],[]];
SPLM.Tooling.DirectUnfoldBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DirectUnfoldBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DirectUnfoldBuilder.Types = Object.freeze({
    "Convert" : "Convert", "MergeBends" : "MergeBends", "DefinePreBends" : "DefinePreBends", "DeleteBends" : "DeleteBends"});

SPLM.Tooling.DirectUnfoldBuilder.BodyList = Object.freeze({
    "None" : "None"});

SPLM.Tooling.DirectUnfoldBuilder.MatType = Object.freeze({
    "Steel" : "Steel"});

SPLM.Tooling.DirectUnfoldBuilder.Bend = Object.freeze({
    "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six"});

export default SPLM;